export default "__VITE_ASSET__R79dCCnN__"